<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col-md-4">
                    <label>Client existant? </label>
                    <select name="renfort_reinforcements" v-model="selectedCustomer" class="form-control">
                        <option disabled value="">----- Veuillez sélectionner -----</option>
                        <option v-for="selectedCustomer in existingCustomers" :value="selectedCustomer">{{ selectedCustomer.name }} {{ selectedCustomer.lastname }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>Type de client *</label>
            <div>
                <input type="radio" id="individuel" name="cust" value="individuel" v-model="picked">
                <label for="individuel">Individuel</label>
                <input type="radio" id="structure" name="cust" value="structure" v-model="picked">
                <label for="structure">Structure (association, OT, agence, etc.)</label>
            </div>
        </div>
        <div v-if="picked != 'structure'">
            <div class="form-group">
                <label>Nom du client * </label>
                <input type="text" name="lastname" placeholder="Exemple : Dupond" class="form-control" v-model="customer.lastname" required />
            </div>
            <div class="form-group">
                <label>Prénom du client *  </label>
                <input type="text" placeholder="Exemple : Jean-michel" name="name" class="form-control" v-model="customer.name" required />
            </div>
            <input type="hidden" name="siret" class="form-control" value=""/>
            <input type="hidden" name="type" value="individual" />
            <input type="hidden" name="external_masse" class="form-control" value="0"/>
        </div>
        <div v-else>
            <div class="form-group">
                <label>Nom de la structure * </label>
                <input type="text" placeholder="Exemple : Office du tourisme de Sallanches" name="lastname" class="form-control" v-model="customer.lastname" required />
            </div>
            <input type="hidden" name="name" class="form-control" value=""/>
            <input type="hidden" name="type" value="structure" />
            <div class="form-group">
                <label>Siret</label>
                <input type="text" name="siret" placeholder="Exemple : 12345678912345" pattern="^[0-9]{14}$" title="14 chiffres uniquement" class="form-control" v-model="customer.siret"/>
            </div>
        </div>
        <div class="form-group">
            <label>Email   </label>
            <input type="email" name="email" placeholder="Exemple : michmich@gmail.com" class="form-control" v-model="customer.email"/>
        </div>
        <div class="form-group">
            <label>Téléphone  </label>
            <input type="phone" name="phone" placeholder="Exemple : 0033605040302"  title="chiffres uniquement" class="form-control" maxlength="14" v-model="customer.phone" />
        </div>
        <div class="form-group">
            <label>Adresse:</label>
            <input type="text" class="form-control" name="adress" placeholder="Exemple : 2 rue de la ville" v-model="customer.adress"/>
        </div>
        <div class="form-group">
            <label>Date de Naissance  </label>
            <input-date class="form-control datepicker" name="birthdate"  v-model="customer.birthdate" :clearbutton="true"></input-date>
           <!-- <input type="phone" name="phone" placeholder="Exemple : 0605040302" pattern="^0[0-9]{9}$" title="9 chiffres uniquement" class="form-control" maxlength="10" v-model="customer.birthdate" />-->
        </div>
        <input type="hidden" name="existingCustomerId" class="form-control" :value="customer.id"/>
    </div>
</template>

<script>
    export default {

        name: 'enterpriseCustomerBilling',
        props: ['oldbilling','oldcustomer','hasmodulebureau', 'officeCustomers'],
        data () {
            return {
                billing: Object.assign({}, this.oldbilling),
                customer : Object.assign({}, this.oldcustomer),
                existingCustomers: Object.assign([], this.officeCustomers),
                selectedCustomer : '',
                picked : 'individuel',

            }
        },
        mounted(){
            if(this.oldcustomer.name == null && this.oldcustomer.email != null){
                this.picked = 'structure'
            }

        },
        watch: {
            selectedCustomer: function (value) {
                this.customer = value // log it BEFORE model is changed
            }
        }
    }
</script>
